import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import JobModel from 'models/Job';
import { ThemeContext } from 'utils/theme';

import Wrapper from './styled/Wrapper';
import Heading from './styled/Heading';
import Title from './styled/Title';
import Paragraph1 from './styled/Paragraph1';
import OpenPositionsHeading from './styled/OpenPositionsHeading';
import OpenPositions from './styled/OpenPositions';
import OpenPositionRole from './styled/OpenPositionRole';
import Paragraph2 from './styled/Paragraph2';
import EmailLink from './styled/EmailLink';
import ContentWrapper from './styled/ContentWrapper';
import { Router, withRouter } from 'next/router';
import OpenPosition from '../OpenPosition/OpenPosition';
import Link from 'next/link';

export default class JobsSection extends PureComponent {
  static defaultProps = {};

  static contextType = ThemeContext;

  onEmailClick = () => {
    // if(appState.analytics)appState.analytics._trackEvent('AboutPage', 'click email', 'career');
  };

  render() {
    const {
      className,
      heading,
      title,
      paragraph1,
      openPositionsHeading,
      openPositions,
      paragraph2,
      email,
      childRef,
    } = this.props;

    return (
      <Wrapper ref={childRef} className={className}>
        {heading && <Heading  theme={this.context}>{heading}</Heading>}
        <Title  theme={this.context}>{title}</Title>
        <ContentWrapper  >
          <Paragraph1 theme={this.context}>{paragraph1}</Paragraph1>
          <OpenPositionsHeading theme={this.context}>
            {openPositionsHeading}
          </OpenPositionsHeading>
          <OpenPositions>
            {openPositions.map(position => (
              <Link href={`/careers/${position.searchQueryName}`}>
                <OpenPositionRole> {position.role} </OpenPositionRole>
              </Link>
            ))}
          </OpenPositions>
          <Paragraph2 theme={this.context}>{paragraph2}</Paragraph2>
          <EmailLink
            theme={this.context}
            label={email}
            link={`mailto:${email}`}
            target="_blank"
            onClick={this.onEmailClick}
          />
        </ContentWrapper>
      </Wrapper>
    );
  }
}
